import axios from 'axios';
import ApiConstants from './apiConstants';

const apiInstanceJavaService = axios.create({
  baseURL: process.env.REACT_APP_REGISTER_JAVA_URL_UPDATED,
  timeout: 5000,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
    'Content-Type': 'application/json',
    Accept: 'application/json',
    cache: 'no-cache',
    mode: 'cors',
    redirect: 'follow',
    'x-user-agent': 'test',
    referrer: 'no-referrer',
  },
});

apiInstanceJavaService.interceptors.request.use(
  async (config) => {
    // const refreshToken = 'test token';
    // const token = 'test token';
    // config.headers = {
    //   ...config.headers,
    //   Authorization: `bearer ${token}`,
    //   refreshToken: refreshToken,
    // };

    if (!config.headers['Authorization']) {
      delete config.headers['Authorization'];
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export default apiInstanceJavaService;
